var SerpFilters = (function ($) {

    function initSearchTypeSwitch() {
        $('.additional-nav-filters').on('click', function () {
            $(this).toggleClass('open');
            $('.results-filters-form ').toggleClass('open');
        });
        $('.additional-nav-sorting').on('click', function () {
            $('.additional-nav').toggleClass('has-sorting-tab-open');
            $(this).toggleClass('open');
            $('.search-list-info').toggleClass('open');
        });
    }

    return {
        initSearchTypeSwitch: initSearchTypeSwitch
    }
})(jQuery);

$(document).ready(function () {
    if (!$('.additional-nav').length) {
        return;
    }
    SerpFilters.initSearchTypeSwitch();
});